// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const FooterSocialYouTube: React.FC<{ size?: number; color1?: string; className?: string }> = ({
    size = 24,
    className,
}) => (
    <svg className={className} focusable="false" viewBox="0 0 24 24" width={size} height={size}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0m.05 6.75h-.16l-.184.001c-1.047.006-4.574.046-5.566.313a1.88 1.88 0 0 0-1.327 1.329c-.277 1.037-.309 3.07-.313 3.526v.183c.004.456.036 2.49.313 3.526a1.85 1.85 0 0 0 1.327 1.308c1.028.276 4.775.31 5.668.313h.384c.893-.004 4.64-.037 5.668-.313a1.85 1.85 0 0 0 1.327-1.308c.289-1.082.311-3.249.313-3.576v-.083c-.002-.327-.024-2.494-.313-3.576a1.88 1.88 0 0 0-1.327-1.329c-.992-.267-4.52-.307-5.566-.313h-.184zm-1.584 3.04 3.92 2.22-3.92 2.22z"
        />
    </svg>
);

export default React.memo(FooterSocialYouTube);
